import { DataFromUrl, EditClient } from "@/imports-files/pages/admins/dashboard/clients/edit";

export async function getClientNewData(setApiError)
{
    // var client_id   =   window.location.pathname.split('/').slice(-2)[0];
    var client_id   =   new DataFromUrl().getClientId();
    const result    =   await new EditClient().getClientInfo(client_id);
    setApiError(result.request);
    const client    =   result.data.client || null
    const data      =   {
                            props: {
                                        client
                                    }
                        }
    return data;
}
    